import { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import WistiaVideo from './wistia_video';
import { demoItem as demoItemType } from '../proptypes/index';
import { trackDemoCarouselNextOrPrev, trackDemoVideoAction } from '../analytics';

const sortByWeight = (firstItem, secondItem) => {
  const a = firstItem.display_weight;
  const b = secondItem.display_weight;

  // This will put higher weight items at the front, and items with no display_weight at the end
  return (a === null) - (b === null) || +(a < b) || -(a > b);
};

const DemoCarousel = ({ demoItems, appSlug }) => {
  const [selectedIdx, setSelectedIdx] = useState(0);

  const sortedItems = useMemo(() => {
    return demoItems.slice().sort(sortByWeight);
  }, [demoItems]);

  const selectedItem = sortedItems[selectedIdx];
  const maxIdx = sortedItems.length - 1;

  const goTo = idx => {
    let nextIdx = idx;
    if (nextIdx > maxIdx) nextIdx = 0;
    if (nextIdx < 0) nextIdx = maxIdx;
    setSelectedIdx(nextIdx);
    trackDemoCarouselNextOrPrev(appSlug);
  };

  const onVideoPlay = action => {
    trackDemoVideoAction(appSlug, action);
  };

  return (
    <div>
      <div className="carouselContainer">
        {selectedItem.wistia_video_id ? (
          <WistiaVideo videoId={selectedItem.wistia_video_id} onVideoPlay={onVideoPlay} />
        ) : (
          <img src={selectedItem.large_url} alt={selectedItem.description} />
        )}

        <button className="prevButton" type="button" onClick={() => goTo(selectedIdx - 1)}>
          &#10094;
        </button>
        <button className="nextButton" type="button" onClick={() => goTo(selectedIdx + 1)}>
          &#10095;
        </button>

        <div className="countInfo">
          {selectedIdx + 1} out of {sortedItems.length}
        </div>
      </div>
    </div>
  );
};

DemoCarousel.propTypes = {
  demoItems: PropTypes.arrayOf(demoItemType).isRequired,
  appSlug: PropTypes.string.isRequired,
};

export default DemoCarousel;
